import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const sizeClass = {
    sm: 'size-[var(--avatar-sm)] text-[length:var(--fs-ui-micro)]',
    md: 'size-[var(--avatar-md)] text-[length:var(--fs-ui-caption)]',
    lg: 'size-[var(--avatar-lg)] text-[length:var(--fs-ui)]'
};
/** Image or initials avatar for people, assignees, and the signed-in user. */ export const SpecraAvatar = /*#__PURE__*/ React.forwardRef(({ className, imageProps, name, size = 'md', src, style, ...props }, ref)=>{
    const initials = name.trim().split(/\s+/).map((part)=>part[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();
    return /*#__PURE__*/ _jsx("span", {
        ...props,
        "aria-label": name,
        className: cn('inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-[var(--avatar-background)] font-medium tracking-[var(--ls-body)] text-[var(--avatar-foreground)]', typeof size === 'number' ? undefined : sizeClass[size], className),
        ref: ref,
        role: "img",
        style: typeof size === 'number' ? {
            width: size,
            height: size,
            fontSize: size * 0.4,
            ...style
        } : style,
        children: src ? /*#__PURE__*/ _jsx("img", {
            alt: "",
            ...imageProps,
            className: cn('size-full object-cover', imageProps?.className),
            src: src
        }) : initials || '—'
    });
});
SpecraAvatar.displayName = 'SpecraAvatar';
